var defaultCellRenderer = function (_a) {
    var cellData = _a.cellData;
    return cellData;
};
export default defaultCellRenderer;
//# sourceMappingURL=defaultCellRenderer.js.map